var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 64,
    width: 45.2549,
    height: 45.2549,
    transform: "rotate(-135 32 64)",
    fill: "#181818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0492 19.9216C32.4697 19.3421 31.5303 19.3421 30.9508 19.9216L21.5082 29.3642C20.9287 29.9436 20.9287 30.8831 21.5082 31.4626C22.0876 32.042 23.0271 32.042 23.6066 31.4626L32 23.0691L40.3935 31.4626C40.9729 32.042 41.9124 32.042 42.4918 31.4626C43.0713 30.8831 43.0713 29.9436 42.4918 29.3642L33.0492 19.9216ZM33.4838 42.4854L33.4838 20.9707L30.5162 20.9707L30.5162 42.4854L33.4838 42.4854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.808bd656fed346ff6083772e92af52c2.svg";
export { ForwardRef as ReactComponent };